'use client';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import HelpCard from './HelpCard';
import CalendlyModal from '../Modal/CalendlyModal';
import { useUser } from '@clerk/nextjs';
import { useTranslate } from '@tolgee/react';
import { closeOrientationCallModal, openOrientationCallModal } from '@/redux/reducers/modalSlice';
import type { RootState } from '@/redux/store';

const OrientationCallCard: React.FC = () => {
  const dispatch = useDispatch();
  const isOrientationCallModalOpen = useSelector(
    (state: RootState) => state.modal.isOrientationCallModalOpen,
  );

  const [isModalOpen, setIsModalOpen] = useState(isOrientationCallModalOpen);

  const openModal = () => {
    setIsModalOpen(true);
    dispatch(openOrientationCallModal());
  };

  const closeModal = () => {
    setIsModalOpen(false);
    dispatch(closeOrientationCallModal());
  };

  useEffect(() => {
    setIsModalOpen(isOrientationCallModalOpen);
  }, [isOrientationCallModalOpen]);

  const { user } = useUser();
  const calendlyUrl = process.env.NEXT_PUBLIC_ORIENTATION_CALL_URL;
  const userId = user?.id ?? '';
  const fullUrl = `${calendlyUrl}?utm_campaign=${userId}`;
  const { t } = useTranslate();

  return (
    <>
      <HelpCard
        title={t('orientation_call_card.title.label')}
        description={t('orientation_call_card.description.label', '')}
        buttonText={t('orientation_call_card.button.book_now.label')}
        buttonVariant="primary"
        backgroundColor="bg-black"
        buttonBorderColor="border-white"
        textColor="text-white"
        backgroundImage="/img/orientation/visual.png"
        onButtonClick={openModal}
      />
      <CalendlyModal isOpen={isModalOpen} onClose={closeModal} url={fullUrl} />
    </>
  );
};

export default OrientationCallCard;
